/* eslint-disable import/no-commonjs */
const MarkdownIt = require('markdown-it')
const resource_order = [
  'resource',
  'resource_action',
  'resource_id',
  'resource_id_action',
]
const orderOperations = { post: 1, get: 2, put: 3, patch: 4, delete: 5 }
function identifyType(path) {
  const numArguments = path.split('/').length

  if (numArguments === 2) {
    return 'resource'
  } else if (numArguments === 3) {
    if (path.endsWith('{id}')) {
      return 'resource_id'
    }

    return 'resource_action'
  }

  return 'resource_id_action'
}
/**
 * sortFnResourceOrId - Sorts the API for
 *
 * @param  {object} a first element
 * @param  {object} b second element
 * @return {integer}   integer to determine sort order.
 */
function sortFnResourceOrId(a, b) {
  const methodComparison = orderOperations[a.method] - orderOperations[b.method]

  if (methodComparison === 0) {
    return a.path.localeCompare(b.path)
  }

  return methodComparison
}
function sortFnResourceIdAction(a, b) {
  const pathComparison = a.path.localeCompare(b.path)
  if (pathComparison === 0) {
    return orderOperations[b.method] - orderOperations[a.method]
  }

  return pathComparison
}

const isDeprecated = (parameter) => {
  return parameter.description?.toLowerCase().includes('deprecated')
}

const hasDeprecatedFields = (parameters) => {
  return parameters.some((param) => isDeprecated(param))
}

module.exports = {
  calculateScore: function calculateScore(path) {
    const type = identifyType(path)
    return resource_order.indexOf(type)
  },
  mergeBuckets: function mergeBuckets(typedBuckets) {
    let sortedTagOperations = []

    Object.keys(typedBuckets).forEach((opKey) => {
      const operations = typedBuckets[opKey]
      let sortedOperations = []

      if (operations.length < 2) {
        sortedTagOperations = sortedTagOperations.concat(operations)
      } else {
        if (opKey === '1' || opKey === '3') {
          sortedOperations = operations.sort(sortFnResourceIdAction)
        } else {
          sortedOperations = operations.sort(sortFnResourceOrId)
        }

        sortedTagOperations = sortedTagOperations.concat(sortedOperations)
      }
    })
    return sortedTagOperations
  },

  /* Taken from dxm-content-gen/utils.js
   * Used for parsing Markdown (with embedded HTML) on API Ref pages
   */
  parseMarkdown: function parseMarkdown(mdContent) {
    const markdownIt = new MarkdownIt({
      html: true,
      breaks: false,
      linkify: true,
      tables: true,
    })
    let breaks = '<br/>'
    let mdContentBody = markdownIt.render(mdContent)
    let normalizedString = mdContentBody.trim()
    const pIndex = normalizedString.indexOf('</p>')

    if (pIndex > -1) {
      // strip leading and closing p tags
      normalizedString = normalizedString.replace(/^<p>|<\/p>$/g, '')

      // if </p> exists in more places than just the end of the normalizedString
      // (subtract 3 places from the pIndex for the leading <p> that we just removed)
      if (normalizedString.length !== pIndex - 3) {
        normalizedString = normalizedString
          // replace closing P tags with BR tags
          .replace(/<\/p>/g, breaks)
          // replace the rest of the opening P tags
          .replace(/<p>/g, '')
      }
    }

    return normalizedString
  },
  isDeprecated,
  hasDeprecatedFields,
}
